import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';

import { ModuleDialogs } from '../../constants/Dialogs';
import { ModuleTemplates } from '../../constants/EmailTemplateTypes';

import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';
import EmailTemplateActions from '../../actions/EmailTemplateActionCreator';
import EmailTemplateStore from '../../stores/EmailTemplateStore';
import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleReminderStore, { createDraft } from '../../stores/ModuleReminderStore';

import { Card, CardActions, CardHeader } from 'material-ui/Card';
import Divider from 'material-ui/Divider';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';
import { List, ListItem } from 'material-ui/List';
import ReminderDialog from '../Reminder/ReminderDialog';

import EmailIcon from 'material-ui/svg-icons/communication/email';
import NotificationIcon from 'material-ui/svg-icons/social/notifications';

const ModuleReminderListItem = ({data}) => {

    let itemProps = {
        primaryText: `${data.number} ${data.unit}`,
        onTouchTap: () => DialogActions.open(ModuleDialogs.REMINDER_EDIT, data)
    };

    if (!!data.templateName) {
        itemProps.secondaryText = data.templateName;
    }
    switch (data.type) {
        case 'email':           itemProps.leftIcon = <EmailIcon />; break;
        case 'notification':    itemProps.leftIcon = <NotificationIcon/>; break;
        default: break;
    }

    return (<ListItem {...itemProps} />);
};

ModuleReminderListItem.propTypes = {
    data:   PropTypes.shape({
        number:     PropTypes.number.isRequired,
        unit:       PropTypes.string.isRequired,
        type:       PropTypes.string.isRequired,
        templateName: PropTypes.string
    })
};

class ModuleReminderCard extends Component {

    componentDidMount() {
        this.addReminder = this.addReminder.bind(this);
        this.updateReminder = this.updateReminder.bind(this);
        this.removeReminder = this.removeReminder.bind(this);
        this.removeAllReminders = this.removeAllReminders.bind(this);
        this.onTemplateLoad = this.onTemplateLoad.bind(this);

        ModuleActions.getReminders(this.props.moduleId);

        EmailTemplateStore.addChangeListener(this.onTemplateLoad);
        EmailTemplateActions.getByType(ModuleTemplates.MODULE_REMINDER);
    }

    componentWillUnmount() {
        EmailTemplateStore.removeChangeListener(this.onTemplateLoad);
    }

    render() {

        const iconProps = {
            color: 'rgba(117, 117, 117 ,0.7)',
        };

        return (
            <Card className="cent-card cent-card-12">
                <CardHeader
                    title="Reminders"
                    subtitle='manage reminder notifications'
                    avatar={<NotificationIcon {...iconProps}/>}
                />
                <List>
                    {this.state.reminders.map(reminder => <ModuleReminderListItem key={reminder.id} data={reminder} />)}
                </List>
                <Divider />
                <CardActions>
                    <FlatButton label="Add" onTouchTap={() => DialogActions.open(ModuleDialogs.REMINDER_ADD, createDraft(this.props.moduleId))} />
                    <FlatButton label="Clear" onTouchTap={this.removeAllReminders} disabled={this.state.reminders.length === 0} />
                </CardActions>
                {!!this.state.isFetching && <LinearProgress method="indeterminate" />}
                {this.getDialog()}
            </Card>
        );
    }


    addReminder(draft) {
        ModuleActions.addReminder(this.state.moduleId, draft);
    }

    updateReminder(draft) {
        const current = this.state.reminders.find(r => r.id === draft.id);
        ModuleActions.updateReminder(current, draft);
    }

    removeReminder(draft) {
        const current = this.state.reminders.find(r => r.id === draft.id);
        ModuleActions.removeReminder(current);
    }

    removeAllReminders() {
        if (confirm("Are you sure you want to clear all reminders?")) {
            ModuleActions.removeAllReminders(this.props.moduleId);
        }
    }

    getDialog() {
        if (!this.state.dialog) { return null; } // guard

        switch (this.state.dialog) {
            case ModuleDialogs.REMINDER_ADD:
                return (
                    <ReminderDialog
                        onSave={this.addReminder}
                        templates={this.state.templates}
                    />
                );

            case ModuleDialogs.REMINDER_EDIT:
                return (
                    <ReminderDialog
                        onSave={this.updateReminder}
                        onRemove={this.removeReminder}
                        templates={this.state.templates}
                    />
                );

        }
    }

    onTemplateLoad() {
        const templates = EmailTemplateStore.getByType(ModuleTemplates.MODULE_REMINDER);
        if (!!templates) {
            this.setState({templates});
        }
    }
}

ModuleReminderCard.getStores = () => ([ModuleReminderStore, DialogStore]);
ModuleReminderCard.calculateState = (prevState, {moduleId}) => ({
    moduleId,
    templates:  (!!prevState && prevState.templates) || [],
    isFetching: ModuleReminderStore.isFetching(),
    reminders:  ModuleReminderStore.getByModule(moduleId),
    dialog:     DialogStore.getOpenDialog()
});

ModuleReminderCard.propTypes = {
    moduleId:   PropTypes.number.isRequired
};

export default Container.create(ModuleReminderCard, {withProps: true});
